import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts),
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts),
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products"),
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    // Cible le footer de page (.footer), pas n'importe quel <footer> : le player
    // Kurtens Stories injecte un <footer class="kst__footer"> en haut du DOM dont
    // le rect (top:0) ferait croire au sticky que le footer est toujours visible.
    const footer = document.querySelector("footer.footer");
    if (!primaryBtn) return;
    const scrollToCartBtn = this.querySelector("[data-scroll-to-cart]");
    if (scrollToCartBtn) {
      scrollToCartBtn.addEventListener("click", function (event) {
        event.preventDefault();
        primaryBtn.scrollIntoView({ behavior: "smooth", block: "center" });
        const mainSubmit = primaryBtn.querySelector(".product-form__submit");
        if (mainSubmit && !mainSubmit.disabled) {
          window.setTimeout(function () {
            mainSubmit.focus({ preventScroll: true });
          }, 500);
        }
      });
    }
    var isVisible = true;
    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            const buttonRect = primaryBtn.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            if (footer) {
              const footerRect = footer.getBoundingClientRect();
              if (footerRect.top < window.innerHeight - 100) {
                _this.classList.remove("show-sticky-cart");
                document.documentElement.classList.remove(
                  "show-sticky-cart-active",
                );
                isVisible = true;
              } else {
                if (
                  !isVisible &&
                  buttonRect.top < viewportHeight &&
                  buttonRect.bottom > 0
                ) {
                  isVisible = true;
                  _this.classList.remove("show-sticky-cart");
                  document.documentElement.classList.remove(
                    "show-sticky-cart-active",
                  );
                } else if (isVisible && buttonRect.bottom <= 0) {
                  isVisible = false;
                  _this.classList.add("show-sticky-cart");
                  document.documentElement.classList.add(
                    "show-sticky-cart-active",
                  );
                }
              }
            } else {
              if (
                !isVisible &&
                buttonRect.top < viewportHeight &&
                buttonRect.bottom > 0
              ) {
                isVisible = true;
                _this.classList.remove("show-sticky-cart");
                document.documentElement.classList.remove(
                  "show-sticky-cart-active",
                );
              } else if (isVisible && buttonRect.bottom <= 0) {
                isVisible = false;
                _this.classList.add("show-sticky-cart");
                document.documentElement.classList.add(
                  "show-sticky-cart-active",
                );
              }
            }
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true },
    );
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
